import "../../styles/Newsfeed.css";
import balance from "../../images/balance.svg";
import tracker from "../../images/tracker.svg";
import collaboration from "../../images/collaboration.svg";
import viz from "../../images/viz.svg";
import season from "../../images/season.svg";
import { NavLink } from "react-router-dom";
import { ReactComponent as ArrowRight } from "../../images/arrow-right.svg";

function Newsfeed() {
  return (
    <main className="main newsfeed">
      <article className="article">
        <img src={season} alt="season" className="article-img" />
        <div className="article-text">
          <div className="article-category">Time Management</div>
          <div className="article-heading">
            How to apply Pomodoro Technique to use your time well
          </div>
          <div className="article-passage">
            Lorem ipsum dolor sit amet, consectetur adipisicing elit. Laborum,
            ut aliquid eligendi voluptatem qui id in iste ea enim quo ipsa esse
            perspiciatis, alias quidem repellendus vitae illum dolore a.
          </div>

          <NavLink to="/" className="btn btn-fill btn-article">
            {" "}
            Go to <ArrowRight className="btn-icon" />{" "}
          </NavLink>
        </div>
      </article>
      <article className="article">
        <img src={balance} alt="balance" className="article-img" />
        <div className="article-text">
          <div className="article-category">Multi-tasking</div>
          <div className="article-heading">
            10 Essential Tips to Help you Multi-task well
          </div>
          <div className="article-passage">
            Lorem ipsum dolor sit amet, consectetur adipisicing elit. Laborum,
            ut aliquid eligendi voluptatem qui id in iste ea enim quo ipsa esse
            perspiciatis, alias quidem repellendus vitae illum dolore a.
          </div>

          <NavLink to="/" className="btn btn-fill btn-article">
            {" "}
            Go to <ArrowRight className="btn-icon" />{" "}
          </NavLink>
        </div>
      </article>
      <article className="article">
        <img src={tracker} alt="tracker" className="article-img" />
        <div className="article-text">
          <div className="article-category">Tracking</div>
          <div className="article-heading">
            The Ultimate Habit Tracker Guide: Why and How to Track Your Habits
          </div>
          <div className="article-passage">
            Lorem ipsum dolor sit amet, consectetur adipisicing elit. Laborum,
            ut aliquid eligendi voluptatem qui id in iste ea enim quo ipsa esse
            perspiciatis, alias quidem repellendus vitae illum dolore a.
          </div>

          <NavLink to="/" className="btn btn-fill btn-article">
            {" "}
            Go to <ArrowRight className="btn-icon" />{" "}
          </NavLink>
        </div>
      </article>
      <article className="article">
        <img src={collaboration} alt="collaboration" className="article-img" />
        <div className="article-text">
          <div className="article-category">Collaboration</div>
          <div className="article-heading">
            Five Collaboration Techniques to Improve Team Performance
          </div>
          <div className="article-passage">
            Lorem ipsum dolor sit amet, consectetur adipisicing elit. Laborum,
            ut aliquid eligendi voluptatem qui id in iste ea enim quo ipsa esse
            perspiciatis, alias quidem repellendus vitae illum dolore a.
          </div>

          <NavLink to="/" className="btn btn-fill btn-article">
            {" "}
            Go to <ArrowRight className="btn-icon" />{" "}
          </NavLink>
        </div>
      </article>
      <article className="article">
        <img src={viz} alt="viz" className="article-img" />
        <div className="article-text">
          <div className="article-category">Visualization</div>
          <div className="article-heading">
            Use visualization to change your habits
          </div>
          <div className="article-passage">
            Lorem ipsum dolor sit amet, consectetur adipisicing elit. Laborum,
            ut aliquid eligendi voluptatem qui id in iste ea enim quo ipsa esse
            perspiciatis, alias quidem repellendus vitae illum dolore a.
          </div>

          <NavLink to="/" className="btn btn-fill btn-article">
            {" "}
            Go to <ArrowRight className="btn-icon" />{" "}
          </NavLink>
        </div>
      </article>
      <article className="article">
        <img src={season} alt="season" className="article-img" />
        <div className="article-text">
          <div className="article-category">Time Management</div>
          <div className="article-heading">
            How to apply Pomodoro Technique to use your time well
          </div>
          <div className="article-passage">
            Lorem ipsum dolor sit amet, consectetur adipisicing elit. Laborum,
            ut aliquid eligendi voluptatem qui id in iste ea enim quo ipsa esse
            perspiciatis, alias quidem repellendus vitae illum dolore a.
          </div>

          <NavLink to="/" className="btn btn-fill btn-article">
            {" "}
            Go to <ArrowRight className="btn-icon" />{" "}
          </NavLink>
        </div>
      </article>
    </main>
  );
}

export default Newsfeed;
